"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_router_dom_1 = require("react-router-dom");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const use_persisted_state_1 = tslib_1.__importDefault(require("use-persisted-state"));
const react_if_1 = require("react-if");
const react_loops_1 = require("react-loops");
const useOsmosysPathGetter_1 = require("../../hooks/useOsmosysPathGetter");
function CardedQuery(_a) {
    var { to, label, prefKey, max, hideable, position, minWidth, showFailState = false, pathToItems, pathToName, pathToLink } = _a, props = tslib_1.__rest(_a, ["to", "label", "prefKey", "max", "hideable", "position", "minWidth", "showFailState", "pathToItems", "pathToName", "pathToLink"]);
    max = isNaN(max) ? 3 : max;
    const useUserPrefs = react_1.default.useMemo(() => use_persisted_state_1.default(`osmosys:userPref:cardedQuery:${prefKey}`), [prefKey]);
    const [hidden, toggleHidden] = react_use_1.useToggle(false);
    const { query } = props, queryProps = tslib_1.__rest(props, ["query"]);
    const resp = react_hooks_1.useQuery(query, queryProps);
    const [userPrefs, setUserPrefs] = useUserPrefs({
        hideCount: 0,
        show: true,
    });
    const items = useOsmosysPathGetter_1.useOsmosysPathGetter(resp.data, pathToItems, []);
    // useUpdateEffect(() => {
    //   toggleHidden(!userPrefs.show);
    // }, [hidden]);
    if (hideable && hidden) {
        return null;
    }
    if (hideable && !userPrefs.show) {
        return (react_1.default.createElement("div", { className: "h-100" },
            react_1.default.createElement(react_2.OsmosysTooltip, { label: "Show emails" },
                react_1.default.createElement(reactstrap_1.Button, { className: "p-0 text-muted", color: "link", onClick: () => {
                        setUserPrefs(Object.assign(Object.assign({}, userPrefs), { hideCount: 0, show: true }));
                    } },
                    react_1.default.createElement("small", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faInbox }))))));
    }
    if (resp.loading) {
        return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "text-muted", icon: pro_light_svg_icons_1.faSpinnerThird, spin: true, rotation: 90 }));
    }
    if (resp.error) {
        return (react_1.default.createElement(reactstrap_1.Fade, { in: showFailState },
            react_1.default.createElement(react_2.OsmosysAlert, { size: "sm", apolloError: resp.error, floatBottom: false },
                react_1.default.createElement("strong", null,
                    "Cannot load ",
                    label))));
    }
    // typeof map.items === 'function'
    // ? map.items(resp.data)
    // : get(resp.data, map.items, []);
    if (!Array.isArray(items) || items.length === 0) {
        if (!showFailState) {
            return null;
        }
        else {
            return react_1.default.createElement("p", { className: "text-muted" },
                "No ",
                label,
                " found");
        }
    }
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "CardedQuery", className: `h-100 overflow-y-auto d-none d-md-flex flex-grow-1 flex-column justify-content-${position ||
            'center'}`, style: { width: '100%' } },
        react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Row, { className: "d-flex flex-row mb-2" },
                react_1.default.createElement(reactstrap_1.Col, { className: "flex-full-col-centered" },
                    react_1.default.createElement("p", { className: "text-muted m-0" }, to ? (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: "text-reset" }, label)) : (label))),
                hideable && (react_1.default.createElement(reactstrap_1.Col, { className: "d-flex flex-grow-0 flex-column" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { href: "#", className: "text-muted", onClick: () => {
                                toggleHidden(true);
                                setUserPrefs(Object.assign(Object.assign({}, userPrefs), { hideCount: userPrefs.hideCount + 1, show: false }));
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes, size: "sm", transform: "up-2", style: {
                                    opacity: 0.75,
                                } })))))),
            react_1.default.createElement(react_loops_1.For, { of: items.slice(0, max === -1 ? items.length : max) }, (item, { index, isFirst, isLast }) => {
                return (react_1.default.createElement(CardedQueryItem, { key: index, item: item, isFirst: isFirst, isLast: isLast, minWidth: minWidth, pathToName: pathToName, pathToLink: pathToLink }));
            }),
            react_1.default.createElement(react_if_1.When, { condition: max !== -1 && items.length > 3 },
                react_1.default.createElement("div", { className: "text-muted" },
                    react_1.default.createElement("p", { className: "mb-0" },
                        react_1.default.createElement("small", null,
                            react_1.default.createElement(react_if_1.If, { condition: !to },
                                react_1.default.createElement(react_if_1.Then, null,
                                    "See ",
                                    items.length - max,
                                    " more"),
                                react_1.default.createElement(react_if_1.Else, null, () => {
                                    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: "text-reset" },
                                        "See ",
                                        items.length - max,
                                        " more"));
                                })))))))));
}
exports.CardedQuery = CardedQuery;
function CardedQueryItem({ item, isLast, minWidth, pathToName, pathToLink, pathToId, }) {
    const itemId = useOsmosysPathGetter_1.useOsmosysPathGetter(item, pathToId || 'id', null);
    const itemTo = useOsmosysPathGetter_1.useOsmosysPathGetter(item, pathToLink, '');
    const itemName = useOsmosysPathGetter_1.useOsmosysPathGetter(item, pathToName, '');
    const cnames = classnames_1.default('px-2 py-1 d-flex flex-row justify-content-between flex-grow-1');
    const wrap = (child) => {
        if (!itemTo) {
            return react_1.default.createElement("span", { className: cnames }, child);
        }
        else {
            return (react_1.default.createElement(react_router_dom_1.Link, { to: itemTo, className: cnames },
                child,
                react_1.default.createElement("div", { className: "flex-col-centered" },
                    react_1.default.createElement(reactstrap_1.Button, { color: "link", className: "pr-0", size: "sm" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowRight })))));
        }
    };
    return (react_1.default.createElement(reactstrap_1.Card, { key: itemId, body: true, className: classnames_1.default('p-0 flex-col-centered shadow-sm', !isLast && 'mb-2') }, wrap(react_1.default.createElement("div", { className: "flex-col-centered", style: {
            maxWidth: '100%',
            minWidth,
            paddingRight: 20,
            width: '100%',
        } },
        react_1.default.createElement("strong", null, itemName)))));
}
//# sourceMappingURL=CardedQuery.js.map